<template>
  <Modal :value="value" :title="modalTitle" :mask-closable="false" @on-visible-change="onVisibleChange">
    <template v-if="mode === 'review'">
      <div class="review-field">
        <div class="review-label">审核结果</div>
        <RadioGroup v-model="decision">
          <Radio label="pass">通过</Radio>
          <Radio label="fail">不通过</Radio>
        </RadioGroup>
      </div>
      <div class="review-field">
        <div class="review-label">定级</div>
        <Select v-model="grade" transfer style="width: 200px">
          <Option v-for="g in grades" :key="g" :value="g">{{ g }}</Option>
        </Select>
      </div>
      <div class="review-field">
        <div class="review-label">意见</div>
        <Input type="textarea" v-model="remark" :autosize="{minRows: 3, maxRows: 6}" :maxlength="500"
          placeholder="填写复审意见…"></Input>
      </div>
    </template>
    <template v-else>
      <div class="result-row">
        <span class="result-label">状态</span>
        <span class="result-value">{{ statusText }}</span>
      </div>
      <div class="result-row">
        <span class="result-label">审核</span>
        <span class="result-value">{{ decisionText }}</span>
      </div>
      <div class="result-row">
        <span class="result-label">定级</span>
        <span class="result-value">{{ (row && row.reviewGrade) || '—' }}</span>
      </div>
      <div class="result-block">
        <div class="result-label">意见</div>
        <div class="result-remark">{{ (row && row.reviewRemark) || '（无）' }}</div>
      </div>
      <div class="result-meta">{{ (row && row.reviewerName) || '' }} · {{ (row && row.reviewTime) || '' }}</div>
    </template>
    <div slot="footer">
      <template v-if="mode === 'review'">
        <Button type="text" @click="close">取消</Button>
        <Button type="primary" :loading="loading" @click="submit">提交复审结果</Button>
      </template>
      <Button v-else @click="close">关闭</Button>
    </div>
  </Modal>
</template>
<script>
import { GRADES, REVIEW_STATUS, findStatus, tchName } from '../recruitConst'

export default {
  name: 'RecruitReviewModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'review'
    }
  },
  data () {
    return {
      grades: GRADES,
      decision: 'pass',
      grade: 'B',
      remark: '',
      loading: false
    }
  },
  computed: {
    modalTitle () {
      let name = tchName(this.row)
      return (this.mode === 'review' ? '复审' : '复审结果') + (name ? ' - ' + name : '')
    },
    statusText () {
      return findStatus(REVIEW_STATUS, this.row && this.row.reviewStatus, 'submit').text
    },
    decisionText () {
      let status = this.row && this.row.reviewStatus
      if (status === 'approved') {
        return '通过'
      }
      if (status === 'rejected') {
        return '不通过'
      }
      return '—'
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.decision = 'pass'
        this.grade = 'B'
        this.remark = ''
        this.loading = false
      }
    }
  },
  methods: {
    onVisibleChange (val) {
      if (!val) {
        this.close()
      }
    },
    close () {
      this.$emit('input', false)
    },
    submit () {
      if (!this.row) {
        return
      }
      if (!this.grade) {
        this.$Message.error('请选择定级')
        return
      }
      let params = {
        tchId: this.row.tchId,
        decision: this.decision,
        grade: this.grade,
        remark: (this.remark || '').trim()
      }
      this.loading = true
      this.$http.post('/tchRecruit/interview/review', params, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          this.$Message.success('复审结果已提交')
          this.close()
          this.$emit('on-success')
        } else {
          this.$Message.error((res && res.msg) || '复审失败')
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.review-field { margin-bottom: 14px; }
.review-label { margin-bottom: 6px; font-size: 13px; font-weight: 600; color: #303133; }
.result-row { display: flex; justify-content: space-between; padding: 8px 12px; border: 1px solid #e9eaec; border-radius: 4px; }
.result-row + .result-row, .result-block { margin-top: 8px; }
.result-block { padding: 8px 12px; border: 1px solid #e9eaec; border-radius: 4px; }
.result-label { color: #808695; }
.result-value { font-weight: 600; }
.result-remark { margin-top: 4px; white-space: pre-wrap; color: #303133; }
.result-meta { margin-top: 10px; font-size: 12px; color: #9AA3B2; }
</style>



// WEBPACK FOOTER //
// RecruitReviewModal.vue?48df228b